// src/components/dayClose/RipplesSkeleton.tsx
// Ripples 視覺化的骨架屏 loading

import React from 'react';

export const RipplesSkeleton: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-6 animate-pulse">
      {/* 標題骨架 */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 mb-2">
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
          <div className="h-8 w-48 bg-gray-200 rounded"></div>
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
        </div>
        <div className="h-4 w-64 bg-gray-200 rounded mx-auto mt-2"></div>
      </div>

      {/* Objectives Ripples 骨架 */}
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
          <div className="h-6 w-32 bg-gray-200 rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={`obj-${i}`}
              className="p-4 rounded-lg border border-gray-200 bg-white"
            >
              {/* Icon 和標題 */}
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                <div className="flex-1">
                  <div className="h-5 w-3/4 bg-gray-200 rounded"></div>
                </div>
              </div>

              {/* Ripples 數字 */}
              <div className="flex items-baseline gap-2">
                <div className="h-10 w-16 bg-gray-200 rounded"></div>
                <div className="h-4 w-24 bg-gray-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Life Dimensions 骨架 */}
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 bg-gray-200 rounded"></div>
          <div className="h-6 w-40 bg-gray-200 rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={`dim-${i}`}
              className="p-4 rounded-lg border border-gray-200 bg-white"
            >
              {/* Icon 和標題 */}
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                <div className="flex-1">
                  <div className="h-5 w-2/3 bg-gray-200 rounded"></div>
                </div>
              </div>

              {/* Ripples 數字 */}
              <div className="flex items-baseline gap-2">
                <div className="h-10 w-16 bg-gray-200 rounded"></div>
                <div className="h-4 w-24 bg-gray-200 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* AI 反饋骨架 */}
      <div className="mb-8 p-4 rounded-lg bg-gray-50 border border-gray-200">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200"></div>
          <div className="flex-1 space-y-2">
            <div className="h-5 w-32 bg-gray-200 rounded"></div>
            <div className="h-4 w-full bg-gray-200 rounded"></div>
            <div className="h-4 w-5/6 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      {/* 繼續按鈕骨架 */}
      <div className="h-12 w-full bg-gray-200 rounded-lg"></div>
    </div>
  );
};
